// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4c92a2e","455":"26e3d945","977":"3a2ab2e4"}[chunkId] + ".chunk.js";
};